export default "__VITE_ASSET__DkzFkbOK__"